// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watermark{z-index:3;position:absolute;bottom:10px;left:10px;pointer-events:none;width:200px;height:auto;filter:drop-shadow(0 0 6px rgba(0,0,0,.2));transition:opacity .3s ease}@media only screen and (max-width:1400px){.watermark{opacity:0}}", ""]);
// Exports
module.exports = exports;
